import { EloHistoryChart } from './EloHistoryChart';
import { WdlByColorMatrix } from './WdlByColorMatrix';
import { MonthlyDeltasTable } from './MonthlyDeltasTable';

/**
 * PerformancePage — 5e onglet "Performance" (Stats Hub V2 PR #H).
 *
 * Compose 3 dashboards cross-cadence / cross-plateforme :
 *
 *  1. Courbe ELO multi-cadence (EloHistoryChart) — la même que Vue globale
 *     mais sans presetage : Léon peut switcher cadence librement, comparer
 *     FIDE / Lichess / chess.com sur la même cadence.
 *
 *  2. WdlByColorMatrix — W/D/L par couleur (Blanc / Noir) croisé avec
 *     cadence (Total / Standard / Rapide / Blitz). Source FFE
 *     (FfeStatsAggregator, PR #E).
 *
 *  3. MonthlyDeltasTable — Δ mensuel par cadence sur 12 derniers mois,
 *     switcheable FIDE / Lichess / chess.com. Source RatingsAggregator
 *     monthlyDeltas (PR #D).
 *
 * Header voix Léon (DESIGN.md §6) : titre "PERFORMANCE" en SmallCaps
 * Space Grotesk + tagline italique factuelle.
 */

export function PerformancePage(): JSX.Element {
  return (
    <div className="flex flex-col gap-6">
      <header>
        <h2 className="text-heading-3 text-paper-50 m-0">
          <span style={{ color: 'var(--paper-50)' }}>PERFORMANCE</span>
          <span className="text-ink-300 text-body ml-2 font-mono uppercase tracking-wider">
            cross-plateforme
          </span>
        </h2>
        <p className="text-body-sm text-ink-300 italic mt-1">
          Cross-plateforme et cross-cadence. Toute la data, croisée.
        </p>
      </header>

      <section>
        <EloHistoryChart cadenceOptions={['classique', 'rapide', 'blitz']} />
      </section>

      <WdlByColorMatrix />

      <MonthlyDeltasTable defaultPlatform="fide" months={12} />
    </div>
  );
}
